import React from 'react';

export default (onSelection, selectedCreatives) => ({
  Header: '',
  key: 'select',
  accessor: 'id',
  Cell: row => (
    <input
      type="checkbox"
      checked={selectedCreatives.includes(row.value)}
      onChange={onSelection.bind(null, row.value)} // eslint-disable-line react/jsx-no-bind
    />
  ),
  width: 25,
  filterable: false,
});
